import('jquery');

function companyAge() {
  const birthdate = new Date(2009, 1, 1);
  const today = new Date();

  const diff = today - birthdate;

  const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  // we use 365.25 because the average year is 365.25 days long. Every 4 years, we add a day to account for leap years.

  document.getElementById('age').innerHTML = age;
}

document.addEventListener('DOMContentLoaded', () => {
  companyAge();
});
